import React, { FC, useMemo } from 'react'
import { Button, Table, Tooltip } from '@wmgtech/legato'
import { Link } from 'react-router-dom'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'
import { Can } from 'shared/abilities'
import { subject } from '@casl/ability'

import { TTableColumn } from 'shared/types'

import { LabelsTableData, LabelsTableProps } from './LabelsTable.props'
import './LabelsTable.scss'

const LabelsTable: FC<LabelsTableProps> = ({ labelsList }) => {
  const labelsListRows: LabelsTableData[] = useMemo(
    () =>
      labelsList.map((label) => {
        const units = label.units?.map((item) => item.name).join(', ') || ''

        return {
          id: label.id,
          name: label.name,
          alias: label.alias,
          unit: units,
          editLink: `/admin/labels/${label.id}`
        }
      }),
    [labelsList]
  )

  const columns: ColumnsType<TTableColumn>[] = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'Zone',
      sortable: false,
      width: 199,
      align: 'left'
    },
    {
      dataIndex: 'alias',
      key: 'alias',
      title: 'Alias',
      sortable: false,
      width: 100,
      align: 'left'
    },
    {
      dataIndex: 'unit',
      key: 'unit',
      title: 'Unit',
      sortable: false,
      align: 'left'
    },
    {
      dataIndex: '',
      key: 'edit',
      title: 'Edit',
      sortable: false,
      align: 'right',
      width: 60,
      render: (value: any, label: any) => {
        return (
          <Can I={'edit'} this={subject('Zone', label)}>
            <Link to={label.editLink} className="labels-table-col-edit__link">
              <Tooltip message="Edit Zone" colorType="dark">
                <Button
                  className="labels-table__edit"
                  icon="pen-to-square"
                  colorType="secondary-black"
                  containerStyle="link"
                />
              </Tooltip>
            </Link>
          </Can>
        )
      }
    }
  ]

  return (
    <Table
      condensed
      className="labels-table"
      columns={columns as any}
      tableLayout="fixed"
      data={labelsListRows}
      rowKey={(record: any) => record.id}
      defaultSort={{
        direction: 'ASC',
        key: 'name'
      }}
      striped={'odd'}
      pagination={false}
    />
  )
}

export default LabelsTable
